import * as React from 'react';
import AppProps from '../../util/AppProps';
import UserProps from '../../util/UserProps';
import { shadowLoginApi } from './ShadowLoginApi';
import {StorageKey} from '../../util/Storage';

class ShadowLogin extends React.Component<AppProps & UserProps> {
    componentDidMount() {
        const params = new URLSearchParams(this.props.location.search);
        const tempToken = params.get('token') as string;
        const bundleParam = params.get('bundle')
        const advertiserIdParam = params.get('advertiserId');
        const advertiserId = advertiserIdParam ? parseInt(advertiserIdParam) : undefined
        if (advertiserId) {
            localStorage.setItem(StorageKey.AdvertiserId, `${advertiserId}`)
        } else {
            localStorage.removeItem(StorageKey.AdvertiserId)
        }

        if (tempToken) {
            shadowLoginApi.completeShadowLogin(tempToken as string).then(() => {
                if (advertiserId) {
                    this.props.history.push('/deliverables');
                } else {
                    this.props.history.push(bundleParam ? '/overview?bundle=' + bundleParam : '/');
                }
            });
        }
    }

    render() {
        return null;
    }
}

export default ShadowLogin;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/shadowlogin/ShadowLogin.tsx